export const settings = {
  Settings: "Settings",
  SettingsDesc: "Adjust your settings here. Click save when finished.",
  Theme: "Theme",
  ToggleTheme: "Toggle theme",
  LightTheme: "Light",
  DarkTheme: "Dark",
  SystemTheme: "System",
  Language: "Language",
  NotificationZero: "No notifications.",
  Install: "Install",
  Maintenance: "Service Maintenance",
  Color: "Color",
} as const;
